<template>
    <div class="col-12 form-group">
        <page-header :title="title" :items="items" />

        <setting-files-dropzones
            with-weather-files
            climate-files-type="residential_rating_calculations"
        />
        <br />

        <b-card
            bg-variant="light"
            header="  Version of partner programs"
            header-class="card-header  p-3 h5"
            header-text-variant="black"
            header-tag="header"
        >
            <div class="d-flex  mt-1">
                <div>
                    <b-form-input
                        v-model="energyPlusVersion"
                        style="width: 100%"
                        :value="energyPlusVersion"
                        @keyup="onKeyUp('energy_plus', energyPlusVersion)"
                    />
                    <label>EnergyPlus version:{{ energyPlusVersion }}</label>
                </div>
                <div class="pl-5">
                    <b-form-input
                        v-model="designBuilderVersion"
                        style="width: 100%"
                        :value="designBuilderVersion"
                        @keyup="onKeyUp('design_builder', designBuilderVersion)"
                    />
                    <label>
                        DesignBuilder version:{{ designBuilderVersion }}
                    </label>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import settingFilesDropzones from '@/components/file/SettingFilesDropzones';

export default {
    page: {
        title: 'Greener - Settings'
    },
    components: {
        settingFilesDropzones
    },

    data() {
        return {
            settings: [],
            items: [
                {
                    text: 'Greener',
                    to: '/'
                },
                {
                    text: 'Settings',
                    active: true
                }
            ],

            files: [],
            energyPlusVersion: 0,
            designBuilderVersion: 0,

            title: 'Settings'
        };
    },

    async created() {
        this.settings = await this.getSettings();

        this.energyPlusVersion = this.settings.find(
            setting => setting.key === 'energy_plus'
        ).value;

        this.designBuilderVersion = this.settings.find(
            setting => setting.key === 'design_builder'
        ).value;
    },

    methods: {
        ...mapActions({
            getSettings: 'settings/index',
            updateSettings: 'settings/update'
        }),

        async onKeyUp(key, value) {
            const { id } = this.settings.find(setting => setting.key === key);
            await this.updateSettings({ id, value: { value } });
        }
    }
};
</script>
